module.exports = __webpack_public_path__ + "static/media/rtos.ee28ea53.jpg";